<!-- <div class="bgimg" style=" position: absolute;
    left: 0;
    top: 0;
    z-index: 9999;
    background: white;
    width: 100%;
    height: 100%;
    border-radius: 10px;">
  <div style="font-size: 24px;
    font-weight: 700;
    margin-bottom: 10px;text-align: center; margin-top: 15%;">
    <p>Hush City server is under maintenance from {{ startDate | date : 'h:mm a'}} to {{ endDate | date : 'h:mm a'}}. Please come back later.</p>
  </div>
</div> -->

<div *ngIf="!complete" id="loading">
  <div class="sk-circle">
    <div class="sk-circle1 sk-child"></div>
    <div class="sk-circle2 sk-child"></div>
    <div class="sk-circle3 sk-child"></div>
    <div class="sk-circle4 sk-child"></div>
    <div class="sk-circle5 sk-child"></div>
    <div class="sk-circle6 sk-child"></div>
    <div class="sk-circle7 sk-child"></div>
    <div class="sk-circle8 sk-child"></div>
    <div class="sk-circle9 sk-child"></div>
    <div class="sk-circle10 sk-child"></div>
    <div class="sk-circle11 sk-child"></div>
    <div class="sk-circle12 sk-child"></div>
  </div>
</div>
<div [ngClass]="{ 'hidden-control' : complete === false }">
  <div class="download clearfix">
    <a href="https://play.google.com/store/apps/details?id=com.hushcity.app&hl=en" target="_blank"><img src="assets/images/play-store.png" alt="Download from Google Play Store"></a>
    <a href="https://itunes.apple.com/us/app/hush-city/id1174145857?mt=8" target="_blank"><img src="assets/images/app-store.png" alt="Download from Apple App Store"></a>
  </div>
  <div id="control-map" class="hush-control clearfix">
    <app-search-map [ngClass]="{ 'hidden-search' : showMap === false }" class="f-left"></app-search-map>
    <app-search-list [ngClass]="{ 'hidden-search' : showList === false }" class="f-left" (keyupAreas)="filterAreas($event)"></app-search-list>
    <div class="btn-ambassadors btn-feature" (click)="openAmbassadors()">
      <img src="assets/images/ambassadors-ic.png" alt="Ambassadors">
    </div>
    <div class="btn-feedback btn-feature" (click)="openFeedback()">
      <img src="assets/images/feedback-ic.png" alt="User feedback">
    </div>
    <ng-container *ngIf="showMap; then searchMap else searchList"></ng-container>
    <ng-template #searchMap>
      <div class="btn-listview btn-feature" (click)="listView()">
        <img src="assets/images/listview-ic.png" alt="List view">
      </div>
    </ng-template>
    <ng-template #searchList>
      <div class="btn-listview btn-feature" (click)="mapView()">
        <img src="assets/images/mapview-ic.png" alt="Map view">
      </div>
    </ng-template>
    <div class="btn-filter btn-feature" (click)="openFilter()">
      <img src="assets/images/filter-ic.png" alt="Filter option">
    </div>
    <div class="btn-legend btn-feature" (click)="openLegend()">
      <img src="assets/images/legend-ic.png" alt="Legend">
    </div>
    <div id="lang-option" class="language-options btn-feature" (click)="toggleLanguage()">
      <img src="assets/images/language-ic.png" alt="Language option">
      <ul id="language-map" [ngClass]="{'show-language' : showLanguage === true}">
        <li (click)="langEn()">
          <img src="assets/images/en-ic.png" alt="English" title="English">
        </li>
        <li (click)="langDe()">
          <img src="assets/images/de-ic.png" alt="German" title="German">
        </li>
        <li (click)="langEs()">
          <img src="assets/images/es-ic.png" alt="Spanish" title="Spanish">
        </li>
        <li (click)="langIt()">
          <img src="assets/images/it-ic.png" alt="Italian" title="Italian">
        </li>
        <li (click)="langPt()">
          <img src="assets/images/br-ic.png" alt="Portuguese" title="Portuguese">
        </li>
      </ul>
    </div>
    <div *ngIf="showMap" class="my-location btn-feature" (click)="getMyLocation()">
      <img src="assets/images/location-ic.png" alt="My location">
    </div>
  </div>
</div>
<app-ambassadors *ngIf="showAmbassadors" (closeClick)="closeAmbassadors()"></app-ambassadors>
<app-feedback *ngIf="showFeedback" (closeClick)="closeFeedback()"></app-feedback>
<app-map-view *ngIf="complete" [ngClass]="{ 'hidden-map' : showMap === false }" [data]="areas" [searchMap]="elementView" [langList]="lang"
  (listView)="listView($event)" (sendFilter)="sendFilter($event)" (here)="listView(true)"></app-map-view>
<app-list-view *ngIf="complete" [ngClass]="{ 'hidden-list' : showList === false }" [data]="areas" [langMap]="lang"
  (mapView)="mapView($event)" (sendFilter)="sendFilter($event)" (kw)="setKeyword($event)"></app-list-view>
<app-filter [ngClass]="{ 'hidden-filter' : showFilter === false }" (filterClick)="filterClick($event)" (closeClick)="closeFilter()"></app-filter>
<app-legend [ngClass]="{ 'hidden-legend' : showLegend === false }" (closeClick)="closeLegend()"></app-legend>